import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "zudoku/hooks";
import { useTenantStore } from "../stores/tenantStore";

export default function useUpdateTenantApplicationAccessLevels(applicationId) {
  const apiAccessUrl = import.meta.env.ZUDOKU_PUBLIC_APIACCESSMANAGEMENT_FA_URL
  const subscriptionKey = import.meta.env.ZUDOKU_PUBLIC_SUBSCRIPTION_KEY
  const {providerData} = useAuth();
  const token = providerData?.accessToken || providerData?.idToken;

  const tenantCode = useTenantStore((state) => state.currentTenant);

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (accessLevels) => {
      const options = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Authorization": `Bearer ${token}`,
          "X-NBLY-Tenant-Code": tenantCode,
          "X-NBLY-Portal-Type": 'participant',
          "Ocp-Apim-Subscription-Key": subscriptionKey,
      },
        body: JSON.stringify({tenantCode, accessLevels}),
      };

      const response = await fetch(`${apiAccessUrl}/${tenantCode}/applications/${applicationId}/accessLevels`, options);

      if (!response.ok) {
        throw new Error("Failed to update tenant application access levels");
      }

      return response.json();
    },
    onSettled: () => {
      queryClient.invalidateQueries(['GET', `${apiAccessUrl}/${tenantCode}/applications/${applicationId}`]);
    }
  });
}